export var getFromStorage = function (key) { return function () {
    try {
        var value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }
    catch (error) {
        return null;
    }
}; };
export var setToStorage = function (key) { return function (value) {
    localStorage.setItem(key, JSON.stringify(value));
}; };
export var removeFromStorage = function (key) {
    localStorage.removeItem(key);
};
